const PlusIcon = ({ ...props }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M6.22222 0V6.22222H0V7.77778H6.22222V14H7.77778V7.77778H14V6.22222H7.77778V0H6.22222Z"
                fill={props.fill || '#080807'}
            />
        </svg>
    )
}
export default PlusIcon
